import { ScrollReveal } from '@/components/ui/scroll-reveal';

export function Features() {
  return (
    <section className="relative py-28 lg:py-40 bg-charcoal-deep overflow-hidden noise">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="font-display font-bold text-[20vw] lg:text-[12rem] text-white/[0.03] whitespace-nowrap">
          THUNDER · THUNDER · THUNDER
        </div>
      </div>

      <ScrollReveal className="relative max-w-6xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-3 mb-8">
          <span className="h-[2px] w-10 bg-thunder" />
          <span className="text-thunder font-display tracking-[0.4em] text-xs">// THE STANDARD</span>
          <span className="h-[2px] w-10 bg-thunder" />
        </div>

        <h2 className="font-display font-bold text-white leading-[0.9] text-4xl sm:text-6xl md:text-7xl lg:text-9xl mb-8">
          <span className="block">YOU'RE CLEAN</span>
          <span className="block text-thunder my-2">OR</span>
          <span className="block">YOU'RE DIRTY</span>
        </h2>

        <p className="text-white/60 font-body text-lg sm:text-xl max-w-2xl mx-auto">
          No grey area. No half-measures. We set the standard and we hit it — every room, every time.
        </p>
      </ScrollReveal>
    </section>
  );
}
